import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
      <path transform="translate(-10.000000, -5.000000)" xmlns="http://www.w3.org/2000/svg" d="M41.7702 65H36.0046L46.5021 35.1818H53.1705L63.6825 65H57.9169L49.9528 41.2969H49.7198L41.7702 65ZM41.9595 53.3086H57.6839V57.6474H41.9595V53.3086Z" fill="currentColor"
      />
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
